export interface WOStatisticsItem {
  uid: number;
  categoryUID: number;
  itemName: string;
  displayOrder: number;
  isDeleted: boolean;
}

export const initializeStatisticsItem: WOStatisticsItem = {
  uid: 0,
  categoryUID: 0,
  itemName: "",
  displayOrder: 0,
  isDeleted: false,
};

export interface statisticsItemListParams {
  token: string;
  page: number;
  rows?: number;
}
export const initialStatisticsItemListParams = {
  page: 1,
  token: "",
  rows: 20,
};
